import { Link } from 'react-router-dom';
import { categories } from '@/mocks/gallery';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900 mb-3">
            风格分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大风格分类，总有一款适合你的审美。点击探索你喜欢的风格，发现更多心动美图。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-[4/5] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                title={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <h3 className="text-base md:text-lg font-bold font-heading text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-white/80">
                  {cat.count} 组作品
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}